<template>
    <b-card>
        <h4 class="card-header">
            Attack Letter Timeline
        </h4>
        <div class="card-body pt-1" style="overflow:auto;" v-if="letters.data && letters.data.length > 0">
            <ul class="timeline ms-50">
                <li class="timeline-item" v-for="(letter, index) in letters.data" :key="index">
                    <span class="timeline-point timeline-point-info" v-if="letter.status.id == 1">
                        <i data-feather="file-text"></i>
                    </span>
                    <span class="timeline-point timeline-point-danger" v-if="letter.status.id == 2">
                        <i data-feather="file-text"></i>
                    </span>
                    <span class="timeline-point timeline-point-success" v-if="letter.status.id == 3">
                        <i data-feather="file-text"></i>
                    </span>
                    <span class="timeline-point timeline-point-warning" v-if="letter.status.id == 4">
                        <i data-feather="file-text"></i>
                    </span>
                    <div class="timeline-event">
                        <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                            <h6>
                                <span class="badge badge-info" v-if="letter.status.id == 1">{{letter.status.status_name}}</span>
                                <span class="badge badge-danger" v-if="letter.status.id == 2">{{letter.status.status_name}}</span>
                                <span class="badge badge-success" v-if="letter.status.id == 3">{{letter.status.status_name}}</span>
                                <span class="badge badge-warning" v-if="letter.status.id == 4">{{letter.status.status_name}}</span>
                            </h6>
                            <span class="timeline-event-time me-1">{{letter.timePosted}}</span>
                        </div>
                        <p class="mb-0">
                            Created {{ letter.timePosted }}
                        </p>
                        <div
                            class="d-flex flex-row align-items-center mt-50"
                            style="cursor:pointer; width: fit-content;"
                            v-on:click="downloadDocument(letter.id)"
                        >
                            <img class="me-1" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/icons/pdf.png" alt="data.json" height="25" style="height:28px;margin-right:4px">
                            <h6 class="mb-0">
                                {{ letter.lettername }} ({{ letter.credit_bureau_name }}).pdf
                            </h6>
                        </div>
                    </div>
                </li>
            </ul>
            <b-row>
                <b-col cols="12">
                    <div class="my-2 d-flex justify-content-center">
                        <pagination v-model="letters.current_page" :records="letters.total" :per-page="letters.per_page" @paginate="getUserDisputes"/>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <p class="text-center font-weight-bold text-capitalize">
                <template v-if="letters.data && letters.data.length <= 0">
                    No Dispute Letter
                </template>
                <template v-else>
                    Loading...
                </template>
            </p>
        </div>
    </b-card>
</template>
<script>
import {
    BCard,
    BRow,
    BCol
} from 'bootstrap-vue-3'
import { ref, reactive, computed } from 'vue'
export default {
    name:'Timeline',
    components:{
    },
    props: {
        id: Number
    },
    setup() {
        return {
            letters: reactive([]),
            baseUrl: baseUrl
        }
    },
    created(){
        this.getUserDisputes(1);
    },
    methods:{
        async getUserDisputes(page){
            let $this = this;
            const route = this.$router.resolve(
                {
                    name: 'attacks-letters',
                    params: {
                        attack: this.id
                    }
                }
            );
            axios.get(
                route.href + `?page=${page}`
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                Object.assign($this.letters, response.data.data);
                setTimeout(() => {
                    if (feather) {
                        feather.replace();
                    }
                }, "1000");
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        },
        downloadDocument(letterId){
            window.location.href = `${this.baseUrl}/disputes/letterDownload/${letterId}`;
        }
    }
}
</script>
